import React, { useContext, useState, useEffect } from "react";
import { ProjectReleaseCurrentTabContext, ProjectReleaseTabContext } from "./context/project_release_context.jsx";
import { DEVELOPER_PROJ_STATUS, DeveloperProjectStatusString } from "../../../constants/developer_proj_status.jsx";
import ProjectRelease from "./components/project_release.jsx";
import "../../../styles/style.css";

const ProjectReleaseLayout = () => {
    const [load, setLoad] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { currentTab, setTab } = useContext(ProjectReleaseCurrentTabContext);
    const { tabs } = useContext(ProjectReleaseTabContext);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    if (!load) {
        return (
            <div className="w-full bg-gray-100 min-h-screen">
                <div className={`${isMobile ? 'p-4' : 'p-6'}`}>
                    {/* Header Section - KEEP ORIGINAL WEB DESIGN */}
                    <div className="md:flex md:items-center md:justify-between">
                        <h2
                            style={{
                                marginLeft: isMobile ? "0px" : "8px",
                                fontSize: isMobile ? "20px" : "18px",
                                marginBottom: isMobile ? "20px" : "25px",
                                fontWeight: "bold",
                                color: "#2A3042",
                                textAlign: isMobile ? "center" : "left"
                            }}
                        >
                            Projects
                        </h2>
                    </div>

                    {/* Content Section */}
                    <div>
                        {/* Menu Tabs Section - Desktop vs Mobile - KEEP ORIGINAL WEB DESIGN */}
                        {isMobile ? (
                            /* Mobile Dropdown */
                            <div className="relative mb-6">
                                <button
                                    onClick={() => setDropdownOpen(!dropdownOpen)}
                                    className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-left shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        color: "#374151"
                                    }}
                                >
                                    <div className="flex items-center justify-between">
                                        <span>{currentTab.name}</span>
                                        <svg
                                            className={`w-5 h-5 transition-transform duration-200 
                                                ${dropdownOpen ? 'rotate-180' : ''}`}
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M19 9l-7 7-7-7"
                                            />
                                        </svg>
                                    </div>
                                </button>

                                {/* Dropdown Menu */}
                                {dropdownOpen && (
                                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                                        {tabs.map((tab) => (
                                            <button
                                                key={tab.value}
                                                onClick={() => { setTab(tab); setDropdownOpen(false) }}
                                                className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors duration-150 
                                                    ${currentTab.name === tab.name
                                                        ? 'bg-blue-50 text-blue-600 font-medium'
                                                        : 'text-gray-700'
                                                    } ${tab.value === 1 ? 'rounded-t-lg' : ''
                                                    } ${tab.value === tabs.length ? 'rounded-b-lg' : 'border-b border-gray-200'
                                                    }`}
                                                style={{
                                                    fontSize: "15px"
                                                }}
                                            >
                                                {tab.name}
                                            </button>
                                        ))}
                                    </div>
                                )}

                                {/* Backdrop to close dropdown */}
                                {dropdownOpen && (
                                    <div
                                        className="fixed inset-0 z-5"
                                        onClick={() => setDropdownOpen(false)}
                                    ></div>
                                )}
                            </div>
                        ) : (
                            /* Desktop Tabs - KEEP ORIGINAL DESIGN */
                            <div
                                className="flex-1 min-w-0 mobile:pt-4 mobile: ml-2"
                                style={{
                                    marginBottom: "0px",
                                    overflowX: "visible"
                                }}
                            >
                                <div className="sm:block pb-4">
                                    <nav className="flex space-x-4" aria-label="Tabs">
                                        {tabs.map((tab) => (
                                            <button
                                                key={tab.value}
                                                onClick={() => setTab(tab)}
                                                className={`button-tab-base ${tab.name === currentTab.name ? "active" : "inactive"}`}
                                                aria-current={tab.name === currentTab.name ? "page" : undefined}
                                            >
                                                {tab.name}
                                            </button>
                                        ))}
                                    </nav>
                                </div>
                            </div>
                        )}

                        {/* Tab Content - FIXED: Now syncs with both mobile and desktop */}
                        {/* {currentTab.value === DEVELOPER_PROJ_STATUS.Pending_Release && ( */}
                        <>
                            <div className={`w-full ${isMobile ? 'mt-2' : ''}`}>
                                {/* Mobile-responsive wrapper */}
                                <div className={`${isMobile
                                    ? 'bg-white rounded-lg shadow-sm mx-auto max-w-full overflow-x-hidden'
                                    : ''
                                    }`}>
                                    <ProjectRelease currentTab={currentTab} />
                                </div>

                                {/* Add mobile-specific padding/spacing */}
                                {isMobile && <div className="h-4"></div>}
                            </div>
                        </>
                        {/* )} */}

                    </div>
                </div>
            </div >
        );
    }

    return (
        <div className="w-full bg-gray-100 min-h-screen">
            <div className="flex items-center justify-center" style={{ minHeight: "50vh" }}>
                <div className="text-center p-8">
                    <div className={`animate-spin rounded-full border-4 border-blue-200 border-t-blue-600 mx-auto mb-4 ${isMobile ? 'h-12 w-12' : 'h-16 w-16'
                        }`}></div>
                    <h3 className={`font-medium text-gray-900 ${isMobile ? 'text-lg' : 'text-xl'}`}>
                        Loading Projects
                    </h3>
                    <p className={`text-gray-600 ${isMobile ? 'text-sm' : 'text-base'}`}>
                        Please wait while we fetch the projects data...
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ProjectReleaseLayout;